function changeInventory(){
    const selectedVariant = document.querySelector('input[name="id[]"]').value;
    const inventoryElement = document.querySelector('.inventory-alerts p');
    const variant = window.themeObject.product.inventory.find(v => String(v.id) === String(selectedVariant));
    console.log('Selected variant match', { selectedVariant, variant });
    const {inventoryMessages} = window.themeObject.product;
    const inventorySettings = window.themeObject.product.inventory.settings;
    
    if (variant) {
      let inventoryMessage = '';
      let inventoryClass = '';
  
      if (variant.continue === 'continue') {
        inventoryMessage = inventoryMessages.inStock;
        inventoryClass = 'in-stock';
      } else if (variant.quantity > inventorySettings.lowStock) {
        inventoryMessage = inventoryMessages.inStock;
        inventoryClass = 'in-stock';
      } else if (variant.quantity > inventorySettings.veryLowStock) {
        inventoryMessage = inventoryMessages.lowStock.replace(/\d+/, variant.quantity);
        inventoryClass = 'low-stock';
      } else if (variant.quantity > 0) {
        if (variant.quantity === 1) {
          inventoryMessage = inventoryMessages.veryLowStockOne.replace(/\d+/, variant.quantity);
        } else {
          inventoryMessage = inventoryMessages.veryLowStock.replace(/\d+/, variant.quantity);
        }
        inventoryClass = 'very-low-stock';
      } else {
        inventoryMessage = inventoryMessages.outOfStock;
        inventoryClass = 'out-of-stock';
      }
  
      inventoryElement.querySelector('span:last-child').innerHTML = inventoryMessage;
      inventoryElement.className = inventoryClass;
    }
  }
  
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelector('variant-radios').addEventListener('change', () => {
      setTimeout(changeInventory, 1000);
    });
  });
  